import * as React from 'react';

interface DetailCardProps {
  title?: string;
  titleAction?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export function DetailCard({ title, titleAction, children, className = '' }: DetailCardProps) {
  return (
    <div className={`bg-white rounded-[20px] border border-[#d9d9d9] p-4 ${className}`}>
      {(title || titleAction) && (
        <div className="flex items-center justify-between mb-3">
          {title && (
            <h3 className="text-[#0A0A9E] font-semibold text-base">{title}</h3>
          )}
          {titleAction}
        </div>
      )}
      {children}
    </div>
  );
}
